import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import useDeviceType from "../hook/useDeviceType";
import MenuBar from "../pages/MenuBar/MenuBar";
import ShowGameDetail from "./ShowGameDetail";
import SponcorFooter from "./SponcorList/SponsorFooter";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import ServicePing from "../pages/Service/ServicePing";
import { isLoggedIn } from "../utils/isLoggedIn";
import { AiOutlineVerticalAlignTop } from "react-icons/ai";
import ScrollToTopIcon from "./scrollToTopIcon/scrollToTopIcon";

const Wrapper = ({ children, scrollToTop }) => {
  const deviceType = useDeviceType();
  const scrollContainerRef = useRef(null);

  const location = useLocation();

  const [showScrollToTop, setShowScrollToTop] = useState(false);

  useEffect(() => {
    if (scrollToTop && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 1000) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  const isStickyLeft = useSelector((state) => state.isStickyLeft);

  return (
    <main className="md:overflow-x-scroll lg:overflow-hidden">
      {isGameBox && deviceType === "Mobile" ? null : <Header />}
      {isGameBox && (
        <div className="relative">
          <div
            className="gamebox-bg min-w-screen"
            style={{
              backgroundImage: `url(https://cdnimages3.gcdn.co/HRJLWPLB/images/SC/Leonbets/egs/LeonRoulette2@1920x1080.jpg)`,
            }}
          ></div>
          <div className="gamebox-gradient"></div>
        </div>
      )}
      <section
        className={`max-w-[1440px] w-full lg:min-w-[1024px] mx-auto lg:h-screen`}
      >
        <div className="h-full flex sm:pt-[56px] pt-[50px]">
          {isGameBox && deviceType === "PC" ? null : (
            <aside
              className={`${
                isStickyLeft ? "lg:min-w-[102px]" : "lg:min-w-[252px]"
              } max-w-[252px] min-w-[0px] overflow-x-hidden`}
            >
              <MenuBar />
            </aside>
          )}

          <main
            ref={scrollContainerRef}
            className={`${isGameBox && "!max-w-[100%]"} ${
              isStickyLeft && "!max-w-[1440px]"
            } max-w-[1188px] lg:min-w-[772px] w-full  max-h-[calc(100vh-56px)] no-scrollbar lg:overflow-y-scroll lg:overflow-x-hidden`}
          >
            {children}
            {isGameBox && deviceType === "Mobile" ? null : <SponcorFooter />}
            {isGameBox && deviceType === "Mobile" ? null : <ShowGameDetail />}
          </main>
          {/* <aside className="lg:min-w-[302px] max-w-[252px] min-w-[0px] overflow-x-hidden  overflow-y-scroll no-scrollbar">
            <PromotionBar />
          </aside> */}
          {/* <aside className="lg:min-w-[252px] max-w-[252px] min-w-[0px] overflow-x-hidden">
            <MenuBarRight />
          </aside> */}
        </div>

        {isGameBox ? null : deviceType === "Mobile" && <Footer />}
        {/* {isLoggedIn() ? <ServicePing isGameBox={isGameBox} /> : null} */}
        {showScrollToTop && (
          <ScrollToTopIcon handleScrollTop={handleScrollTop} />
        )}
        <ServicePing isGameBox={isGameBox} />
      </section>
    </main>
  );
};

export default Wrapper;
